import React, { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import Components from "..";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { doctorActions, patientActions, ehrActions } from "../../core/actions";
import { CASERECORD, DISCHARGESUMMARY } from "../../shared/constants";
import { makeStyles } from "@material-ui/core";
import TextField from "@mui/material/TextField";
import { helperServices } from "../../shared/helper";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import {
  Alert,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { format } from "date-fns";
import { Box, Paper } from "@mui/material";
import { saveDischargeSummary } from "../../core/actions/patientActions";
import { buildDoctorOption } from "../../shared/helper/helper";
import { getStaffList } from "../../core/actions/doctorActions";

// useDebounce hook
function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => clearTimeout(timer);
  }, [value, delay]);
  return debouncedValue;
}

// Fields that should never be set to "Nil Significant"
const EXCLUDED_FIELDS = [
  "Restriction in Physical activity",
  "Diet",
  "Next dose of long Acting Injectable due",
  "supportDate",
  "dischargedt",
  "Appointment Confirmation Number",
  "Admission Type",
  "Ksmha Intimation Number",
  "Nominated Representative",
  "Package of Stay",
  "Advice on discharge",
  "Risk of Self Harm",
  "Communicated To",
  "patient title",
];

function DischargeSummary(props) {
  const [patientEhrid, setPatientEhrId] = useState("");

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ color: [] }, { background: [] }],
      ["link", "image"],
      ["clean"],
    ],
  };

  // ── Refs ──────────────────────────────────────────────────────────────────
  const mySessionIdRef = useRef(null);
  const sessionReadyRef = useRef(false);
  const userHasEdited = useRef(false);
  const summaryLoadedRef = useRef(false);
  //const summaryRef = useRef(INITIAL_SUMMARY); 
  const selectedItemsDocRef = useRef([]);
  const selectedItemsCounsRef = useRef([]);
  const selectedItemsStaffRef = useRef([]);
  const selectedItemsTeleDocRef = useRef([]); // ADDED FOR TELE-CONSULTATION
  // ── State ─────────────────────────────────────────────────────────────────
  const [sessionExpired, setSessionExpired] = useState(false);
  const [sessionOwner, setSessionOwner] = useState("");
  //const [isDataLoaded, setIsDataLoaded] = useState(false);

  const [summary, setSummary] = useState({
    "patient title":"",
    "Chief Complaints": "",
    "Clinical Summary": "<p>Family members report patient was noted to have the above-mentioned symptoms for 2 days, leading to significant socio-occupational dysfunction requiring IP care.</p>",
    "Past and Treatment History": "",
    "Relevant Medical History": "",
    "Relevant Family History": "",
    "Personal History": "",
    "Premorbid Personality": "",
    "Planned Psycho-Social Intervention": "<p>PSYCHOEDUCATION</p><p>SUPPORTIVE THERAPY</p><p>OTHER SPECIFIC THERAPY</p>",
    "Mental State Examination": "<p>On admission,</p><p>MSE- co-operative</p><p>GENERAL APPEARANCE AND BEHAVIOUR-</p><p>Conscious, well oriented to time/place/date</p><p>Thought &amp; Speech-normal</p><p>Mood- normal</p><p>Perception-normal</p><p>Cognition-normal</p><p>Insight present</p>",
    "Final Diagnosis": "<p>PSYCHIATRIC DIAGNOSIS -</p><p> &bull; F31.2- BIPOLAR AFFECTIVE DISORDER; MANIA WITH PSYCHOTIC SYMPTOMS</p><p>CO MORBID ILLNESS-</p><p>HTN</p>",
    "General physical examination": "<p>Bp- 120/80 mm Hg</p><p>HR- 88 b/min</p><p>Spo2 -98% @ RA</p><p>RR-24 bpm</p>",
    "Clinical Investigations": "<p>All report enclosed below</p>",
    "Course of treatment in hospital": "<p>Patient was brought with the above mentioned complaints</p>",
    "Advice on discharge": "",
    "Appointment Confirmation Number": "",
    "Admission Type": "",
    "Ksmha Intimation Number": "",
    "Nominated Representative": "",
    "dischargedt": "",
    "Package of Stay": "",
    "Stressors": "",
    "Forensic History": "",
    "Systemic Examination": "<p>RS-B/L NVBS heard, no added sounds.</p><p>CVS-S1, S2 heard, no added sounds</p><p>P/A- soft and non-tender</p><p>CNS-no FND</p>",
    "Capacity Assessment": "",
    "Other Reports": "<p>All report enclosed below</p>",
    "Other Consultation": "<p>NIL</p>",
    "Relapse Prevention Measures": "<p>Regular in Medicine intake</p><p>To avoid sleep deprivation</p><p>To be away from substance (Alcohol), stress and anxiety situation</p>",
    "Restriction in Physical activity": "",
    "Diet": "",
    "Next dose of long Acting Injectable due": "",
    "supportDate": "",
    "Risk of Self Harm": "Not Present",
    "Communicated To": "Family Member",
  });

  const [dischargeId, setDischargeId] = useState();
  const [patientdetails, setPatientDetails] = useState({ name: "", visitDate: "" });
  const [dischrgeDetails, setDischrgeDetails] = useState({ id: "", patientId: "", dischargeDate: "" });
  const [selectedDoctor, setSelectedDoctor] = useState("");
  const [patientRevisitdetails, setPatientRevisitdetails] = useState("");
  const [dischargedt, setDischargedt] = useState("");
  //const [filterdProList, setfilterdProList] = useState();
  const [loadsummary, setLoadSummary] = useState(false);
  const [formErrors, setFormErrors] = useState({
    "Final Diagnosis": "",
    "Clinical Summary": "",
    "Follow Up Date": "",
    "Chief Complaints": "",
    "Past and Treatment History": "",
    "Relevant Medical History": "",
    "Relevant Family History": "",
    "Personal History": "",
    "Premorbid Personality": "",
    "Psycho-social Factors": "",
    "Mental State Examination": "",
    "General physical examination": "",
    "Clinical Investigations": "",
    "Course of treatment in hospital": "",
    "Advice on discharge": "",
  });

  const useStyles = makeStyles((theme) => ({
    redAsterisk: { color: "red" },
    quillEditor: {
      height: "150px",
      marginBottom: "40px",
      "& .ql-container": { fontSize: "14px", fontFamily: "Arial, sans-serif" },
    },
  }));
  const classes = useStyles();

  const [details, setDetails] = useState({
    id: "", patientId: "", visitId: "", markForDel: "", groupname: "", preparedBy: "", approver: "",
  });
  const [doctorList, setDoctorList] = useState([]);
  const [staffList, setStaffList] = useState([]);
  const [counsellorList, setCounsellorList] = useState([]);
  const [ServerRes, setServerRes] = useState({ success: "", error: "" });
  const dispatch = useDispatch();
  const doctorsDetail = useSelector(
    (state) => state.doctorDetailsState.doctorList
  );
  const [dischargePrint, setdischargePrint] = useState(false);
  const [fullName, setFullName] = useState("");
  const [roomName, setRoomName] = useState("");
  const [phoneNum, setPhoneNum] = useState("");
  const [selectedOptionDoc, setSelectedOptionDoc] = useState(null);
  const [selectedOptionStaff, setSelectedOptionStaff] = useState(null);
  const [selectedOptionCoun, setSelectedOptionCoun] = useState(null);
  const [selectedItemsDoc, setSelectedItemsDoc] = useState([]);
  const [selectedItemsStaff, setSelectedItemsStaff] = useState([]);
  const [selectedItemsCouns, setSelectedItemsCoun] = useState([]);
  // ADDED FOR TELE-CONSULTATION
  const [selectedTeleDoc, setSelectedTeleDoc] = useState(null);
  const [selectedItemsTeleDoc, setSelectedItemsTeleDoc] = useState([]);
  const [teleConsultDoctors, setTeleConsultDoctors] = useState([]);
  const [targetIds, setTargetIds] = useState([]);
  const [followUpDateFlag, setFollowUpDateFlag] = useState(false);
  const [dischargeDateFlag, setDischargeDateFlag] = useState(false);
  const [todayDate, setTodayDate] = useState(new Date());
  const [doctors, setDoctors] = useState([]);
  const [medicalOfficers, setMedicalOfficers] = useState([]);
  const [counsellor, setCounsellor] = useState([]);
  const [dischargeSummarytemplate, setDischargeSummarytemplate] = useState();
  const [labReportData, setLabReportData] = useState("");
  const [adviceRows, setAdviceRows] = useState([
    { medicine: "", dose: "", frequency: "", comment: "" },
    { medicine: "", dose: "", frequency: "", comment: "" },
    { medicine: "", dose: "", frequency: "", comment: "" },
  ]);
  const [doctorLoaded, setDoctorLoaded] = useState(false);
  const [staffLoaded, setStaffLoaded] = useState(false);
  const [autosaveStatus, setAutosaveStatus] = useState("idle");
  const [roomList, setRoomList] = useState([]);

  const debouncedSummary = useDebounce(summary, 5000);

  // ── Keep summaryRef in sync with latest summary state ─────────────────────

  useEffect(() => { selectedItemsDocRef.current = selectedItemsDoc; }, [selectedItemsDoc]);
  useEffect(() => { selectedItemsCounsRef.current = selectedItemsCouns; }, [selectedItemsCouns]);
  useEffect(() => { selectedItemsStaffRef.current = selectedItemsStaff; }, [selectedItemsStaff]);
  useEffect(() => { selectedItemsTeleDocRef.current = selectedItemsTeleDoc; }, [selectedItemsTeleDoc]); // ADDED FOR TELE-CONSULTATION

  // ── Session ID generation ─────────────────────────────────────────────────


const waitForToken = (callback, delay = 200) => {
  const check = () => {
    const token = helperServices.getAuthorization();

    //console.log("Checking token...", token);

    if (token) {
      //console.log("Token found:", token);
      const patientId = props.match.params.patientid;
    const visitId = props.match.params.visitid;

    if (!patientId || !visitId) {
      console.warn("patientId or visitId missing, skipping generateSessionId");
      return;
    }

    dispatch(
      patientActions.generateSessionId(patientId, visitId, (res) => {
        //console.log("generateSessionId raw response:", res);
        const sessionId = res?.procedure?.notes;
        if (sessionId && sessionId.includes('::')) {
          mySessionIdRef.current = sessionId;
          sessionReadyRef.current = true;
          //console.log("Session ID stored:", sessionId);
        } else {
          console.warn("Could not extract session ID:", res);
        }
      })
    );
  
      getStaffList();
      getDoctorList();
      getPatientProfile();
      console.log("selected : ", selectedItemsDoc);
      console.log("selected : ", selectedItemsCouns);
      document.getElementById("mainpage").style.paddingLeft = "0px";
      document.getElementById("sidebar").style.display = "none";
      getDischargeSummarytemplateById();
      console.log("ehrid", patientEhrid);
    } else {
      //console.log("🟡Token is not fetched yet,timeout!!!!!!!!!!")
      setTimeout(check, delay); 
    }
  };

  check();
};
  useEffect(() => {

    waitForToken();
  
  }, []);

  // ── Set "Nil Significant" for empty clinical fields on mount ──────────────
  /*useEffect(() => {
    setSummary((prev) => {
        console.log("🔥1️⃣🔥 setSummary - NilSignificant useEffect:", new Error().stack);
      const updated = { ...prev };
      Object.keys(updated).forEach((key) => {
        if (
          !EXCLUDED_FIELDS.includes(key) &&
          (updated[key] === undefined || updated[key] === null || updated[key].toString().trim() === "")
        ) {
          updated[key] = "Nil Significant";
        }
      });
      return updated;
    });
    userHasEdited.current = false;
  }, []); */

  // ── Initial data fetches ──────────────────────────────────────────────────
  useEffect(() => {
    getStaffList();
    getDoctorList();
    getPatientProfile();
    document.getElementById("mainpage").style.paddingLeft = "0px";
    document.getElementById("sidebar").style.display = "none";
    getDischargeSummarytemplateById();
  }, []);

  // ── Fetch lab reports once EHR ID is available ────────────────────────────
  useEffect(() => {
    if (patientEhrid) {
      getPatientLabReports();
    }
  }, [patientEhrid]);

  // ── Sync advice rows from summary ─────────────────────────────────────────
  useEffect(() => {
    if (!summary) return;
    const list = getAdviceOnDischargeList(summary);
    if (Array.isArray(list) && list.length > 0) {
      setAdviceRows(list);
    }
  }, [summary]);

  // ── Load discharge summary once both lists are ready — runs ONCE only ─────
  useEffect(() => {
    if (doctorLoaded && staffLoaded && !summaryLoadedRef.current) {
      summaryLoadedRef.current = true;
      patientSummaryClick(doctorList, counsellorList);
    }
  }, [doctorLoaded, staffLoaded]);

  // ── Match target IDs to doctor/counsellor/staff/tele ───────────────────────────
  useEffect(() => {
    if (!targetIds.length) return;
    targetIds.forEach(({ id, vaId }) => {
      addIfMatched(doctorList, "doctor", id, setSelectedItemsDoc, vaId);
      addIfMatched(counsellorList, "counsellor", id, setSelectedItemsCoun, vaId);
      addIfMatched(staffList, "medical officer", id, setSelectedItemsStaff, vaId);
      addIfMatchedTele(doctorList, id, setSelectedItemsTeleDoc, vaId); // ADDED FOR TELE-CONSULTATION
    });
  }, [targetIds, doctorList, counsellorList, staffList]);

  // ── Autosave on debounced summary change ──────────────────────────────────
  useEffect(() => {
    if (!debouncedSummary) return;
    if (!mySessionIdRef.current) return;
    if (!sessionReadyRef.current) return;
    // if (!isDataLoaded) return;
    if (!userHasEdited.current) return;

    const patientId = props.match.params.patientid;
    const visitId = props.match.params.visitid;

    dispatch(
      patientActions.validateSessionId(patientId, visitId, mySessionIdRef.current, (res) => {
        if (res && res.successMessages) {
          silentSave();
        } else {
          setAutosaveStatus("idle");
          setSessionExpired(true);
          const owner = res?.errorMessages
            ? (Array.isArray(res.errorMessages) ? res.errorMessages[0] : res.errorMessages)
            : "another user";
          setSessionOwner(owner);
        }
      })
    );
  }, [debouncedSummary]);

  // ── Silent autosave ───────────────────────────────────────────────────────
  const silentSave = () => {
    const patientId = props.match.params.patientid;
    const visitId = props.match.params.visitid;
    var proList = [];
    const keys = Object.keys(summary);
    setAutosaveStatus("saving");
    for (let key of keys) {
      if (key === "session_id") continue;
      proList.push({
        claSS: key,
        notes: key === "Advice on discharge"
          ? JSON.stringify(getDischargeAdviceList())
          : summary[key],
        patientId,
        visitId,
      });
    }
    dispatch(patientActions.saveDischargeSummary(proList, () => {
      setAutosaveStatus("saved");
      setTimeout(() => setAutosaveStatus("idle"), 2000);
      refreshAssignmentIds();
    }));

    if (patientRevisitdetails) {
      dispatch(patientActions.followUpByDoctor(
        { patientId, lastvisitId: visitId, scheduleddate: patientRevisitdetails },
        () => { }
      ));
    }

    const buildAssignments = (items, type) =>
      (items || []).map((item) => ({
        targetid: item.personId,
        visitid: visitId,
        status: "open",
        type,
      }));

    const assignmentList = [
      ...buildAssignments(selectedItemsDocRef.current, "Doctor"),
      ...buildAssignments(selectedItemsCounsRef.current, "counsellor"),
      ...buildAssignments(selectedItemsStaffRef.current, "Medical Officer"),
      ...buildAssignments(selectedItemsTeleDocRef.current, "Tele-consultation"), // ADDED FOR TELE-CONSULTATION
    ];

    if (assignmentList.length > 0) {
      dispatch(patientActions.saveVisitAssignment(assignmentList, () => { }));
    }
    
  };

  // ── Staff list ────────────────────────────────────────────────────────────
  const getStaffList = () => {
    dispatch(
      doctorActions.getStaffList((resCb) => {
        const staff = resCb?.accresp?.personList?.filter(
          (person) => person?.type?.toLowerCase() === "medical officer"
        ) || [];
        setStaffList(staff);
        setStaffLoaded(true);
      })
    );
  };

  // ── EHR template ─────────────────────────────────────────────────────────
  const getDischargeSummarytemplateById = () => {
    dispatch(
      ehrActions.getTemplateById("", "Discharge Summary", {}, (resCb) => {
        if (resCb) setDischargeSummarytemplate(resCb);
      })
    );
  };

  // ── Load discharge summary from API ──────────────────────────────────────
  const patientSummaryClick = (docList, counList) => {
    details.patientId = props.match.params.patientid;
    details.visitId = props.match.params.visitid;
    details.groupname = DISCHARGESUMMARY;
    details.markForDel = false;

    dispatch(
      patientActions.getDischargeSummary(summary, details, (resCb) => {
        if (resCb) {
          const targetId = resCb?.vaList?.[0]?.targetid;
          if (targetId) {
            const matched = docList.find(
              (d) => String(d.personId) === String(targetId)
            );
            if (matched) {
              setSelectedDoctor((matched.displaytitle || "") + (matched.first_name || ""));
            }
          }

          if (resCb?.visit?.dischargeDate) {
            const dt = new Date(resCb.visit.dischargeDate);
            const formatted = format(dt, "yyyy-MM-dd'T'HH:mm");
            setDischargedt(formatted);
          }

          const ids = (resCb.vaList || [])
            .filter((v) => v?.targetid)
            .map((v) => ({ id: v.targetid, vaId: v.id, type: v.type })); // Added type
          setTargetIds(ids);

          if (resCb?.procedureList?.length > 0) {
            if (resCb?.visit) {
              const discharge = resCb.visit.dischargeDate;
              if (discharge) {
                const dt = new Date(discharge);
                const formattedDateTime =
                  `${dt.getUTCFullYear()}-${String(dt.getUTCMonth() + 1).padStart(2, "0")}-${String(dt.getUTCDate()).padStart(2, "0")}T${String(dt.getUTCHours()).padStart(2, "0")}:${String(dt.getUTCMinutes()).padStart(2, "0")}`;
                summary.dischargedt = formattedDateTime;
              }
            }

            if (resCb?.revisit) {
              setPatientRevisitdetails(resCb.revisit.scheduleddate);
            } else {
              const folDate = new Date();
              setPatientRevisitdetails(format(folDate.setDate(folDate.getDate() + 14), "yyyy-MM-dd"));
            }

            const filterList = resCb.procedureList.filter(
              (item) => item?.groupname === DISCHARGESUMMARY
            );
            var dischargeNotes = { ...summary };
            var filteredProList = [];
            filterList.forEach((item) => {
              const resolvedKey = item?.claSS;
              if (resolvedKey in dischargeNotes) {
                dischargeNotes[resolvedKey] = item?.notes;
                filteredProList.push({ ...item, claSS: resolvedKey });
              }
            });
            setSummary({ ...dischargeNotes });
            userHasEdited.current = false;

          } else {
            details.groupname = CASERECORD;
            dispatch(
              patientActions.getDischargeSummary(summary, details, (resCb2) => {
                if (resCb2?.procedureList) {
                  if (resCb2?.revisit) {
                    setPatientRevisitdetails(resCb2.revisit.scheduleddate);
                  } else {
                    const folDate = new Date();
                    setPatientRevisitdetails(format(folDate.setDate(folDate.getDate() + 14), "yyyy-MM-dd"));
                  }

                  if (resCb2?.visit) {
                    const discharge = resCb2.visit.dischargeDate;
                    if (discharge) {
                      const dt = new Date(discharge);
                      const formattedDateTime =
                        `${dt.getUTCFullYear()}-${String(dt.getUTCMonth() + 1).padStart(2, "0")}-${String(dt.getUTCDate()).padStart(2, "0")}T${String(dt.getUTCHours()).padStart(2, "0")}:${String(dt.getUTCMinutes()).padStart(2, "0")}`;
                      setDischargedt(formattedDateTime);
                    } else {
                      const d = new Date();
                      setDischargedt(
                        `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}T${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`
                      );
                    }
                  }

                  const filterList2 = resCb2.procedureList.filter(
                    (item) => item?.groupname === CASERECORD
                  );
                  var dischargeNotes2 = { ...summary };
                  var filteredProList2 = [];
                  filterList2.forEach((item) => {
                    const resolvedKey = item?.claSS;
                    if (resolvedKey in dischargeNotes2) {
                      dischargeNotes2[resolvedKey] = item?.notes;
                      filteredProList2.push({ ...item, claSS: resolvedKey });
                    }
                  });
                  setSummary({ ...dischargeNotes2 });
                  userHasEdited.current = false;
                }
              })
            );
          }
        }
      })
    );
  };

  const addIfMatched = (list = [], type, targetId, setState, vaId) => {
    if (!targetId || !type || !list.length) return;
    const matched = list.find(
      (item) =>
        String(item?.personId) === String(targetId) &&
        item?.type?.toLowerCase() === type.toLowerCase()
    );
    if (!matched) return;
    setState((prev) =>
      prev.some((p) => p.personId === matched.personId)
        ? prev
        : [...prev, { ...matched, vaId }]
    );
  };
  
  // ADDED FOR TELE-CONSULTATION - Separate matcher that ignores type
  const addIfMatchedTele = (list = [], targetId, setState, vaId) => {
    if (!targetId || !list.length) return;
    const matched = list.find(
      (item) => String(item?.personId) === String(targetId)
    );
    if (!matched) return;
    setState((prev) =>
      prev.some((p) => p.personId === matched.personId)
        ? prev
        : [...prev, { ...matched, vaId }]
    );
  };
  
  const refreshAssignmentIds = useCallback(() => {
    const patientId = props.match.params.patientid;
    const visitId = props.match.params.visitid;

    const queryDetails = {
      patientId,
      visitId,
      groupname: DISCHARGESUMMARY,
      markForDel: false,
    };

    dispatch(
      patientActions.getDischargeSummaryForAutoSave({}, queryDetails, (resCb) => {
        if (!resCb?.vaList?.length) return;

        const ids = resCb.vaList
          .filter((v) => v?.targetid)
          .map((v) => ({ id: v.targetid, vaId: v.id, type: v.type }));

        setSelectedItemsDoc((prev) => {
          const updated = prev.map((item) => {
            const match = ids.find((x) => String(x.id) === String(item.personId));
            return match ? { ...item, vaId: match.vaId } : item;
          });
          selectedItemsDocRef.current = updated;
          return updated;
        });

        setSelectedItemsCoun((prev) => {
          const updated = prev.map((item) => {
            const match = ids.find((x) => String(x.id) === String(item.personId));
            return match ? { ...item, vaId: match.vaId } : item;
          });
          selectedItemsCounsRef.current = updated;
          return updated;
        });

        setSelectedItemsStaff((prev) => {
          const updated = prev.map((item) => {
            const match = ids.find((x) => String(x.id) === String(item.personId));
            return match ? { ...item, vaId: match.vaId } : item;
          });
          selectedItemsStaffRef.current = updated;
          return updated;
        });

        // ADDED FOR TELE-CONSULTATION
        setSelectedItemsTeleDoc((prev) => {
          const updated = prev.map((item) => {
            const match = ids.find((x) => String(x.id) === String(item.personId));
            return match ? { ...item, vaId: match.vaId } : item;
          });
          selectedItemsTeleDocRef.current = updated;
          return updated;
        });
      })
    );
  }, [dispatch, props.match.params.patientid, props.match.params.visitid]);

  // Handle Tele-consultation doctor selection
  const handleTeleOptionSelect = (selectedDoctorId) => {
    //userHasEdited.current = true;
    // setSummary(prev => ({ ...prev }));
    const visitId = props.match.params.visitid;

    doctorList.forEach((doc) => {
      if (doc.personId == selectedDoctorId && !selectedItemsTeleDoc.some((i) => i.personId === doc.personId)) {
        setSelectedItemsTeleDoc((prev) => [...prev, doc]);
        setSelectedTeleDoc(selectedDoctorId);

        // Save to backend if needed
        dispatch(patientActions.saveVisitAssignment([{
          targetid: doc.personId,
          visitid: visitId,
          status: "open",
          type: "Tele-consultation",
        }], () => {
          refreshAssignmentIds();
        }));
      }
    });
  };

  // Handle removal of Tele-consultation doctor
  const handleRemoveTeleItem = (item) => {
    const updated = selectedItemsTeleDoc.filter((i) => i !== item);
    selectedItemsTeleDocRef.current = updated;
    setSelectedItemsTeleDoc(updated);
    //setSummary(prev => ({ ...prev }));
    userHasEdited.current = false;

    dispatch(patientActions.removeVisitAssignment([{
      id: item.vaId || null,
      targetid: item.personId,
      visitid: props.match.params.visitid,
      status: "close",
      type: "Tele-consultation",
    }], () => { }));
  };

  const getAdviceOnDischargeList = (summaryData) => {
    const value = summaryData?.["Advice on discharge"];
    if (!value) return [];
    try {
      if (typeof value === "string") return JSON.parse(value);
    } catch (e) {
      console.error("Invalid Advice on discharge JSON", e);
    }
    return [];
  };

  const getPatientProfile = () => {
    const patientId = props.match.params.patientid;
    const visitId = props.match.params.visitid;
    dispatch(
      patientActions.getPatientProfile(patientId,visitId, (resCb) => {
        if (resCb) {
          setPatientEhrId(resCb.ehrid);
          dispatch(patientActions.setPatientDetails(resCb));
          setFullName(`${resCb.fname} ${resCb.mname } ${resCb.lname }`);
          setRoomName(resCb.room?.roomName || "");
          setPhoneNum(resCb.phno);
          setRoomList(resCb.roomList || []);
          setPatientDetails({ resCb });
        }
      })
    );
  };

  const getDoctorList = () => {
    let docList = [];
    let counList = [];
    dispatch(
      doctorActions.getDoctorList({}, (resCb) => {
        if (resCb) {
          const doctorsArray = Array.isArray(resCb) ? resCb : [resCb];
          for (let doctor of doctorsArray) {
            if (doctor?.personId) {
              if (doctor.type.toLowerCase() === "doctor") {
                docList.push(doctor);
              } else if (doctor.type === "Counsellor") {
                counList.push(doctor);
              }
            }
          }
          setDoctorList([...docList]);
          setCounsellorList([...counList]);
          setDoctorLoaded(true);
        }
      })
    );
  };

  // Kept for potential use elsewhere in the project
  const getDoctorsList = (targetid, data) => {
    let gvdata;
    dispatch(
      doctorActions.getDoctorList(data, (resCb) => {
        if (resCb) {
          let list = [];
          for (let doc of resCb) {
            if (doc != null) {
              const opt = buildDoctorOption(doc);
              list.push(opt);
              gvdata = targetid;
              if (gvdata && gvdata == doc.personId) {
                setSelectedDoctor(doc.displaytitle + opt.first_name);
              }
            }
          }
        }
      })
    );
  };

  const getPatientLabReports = () => {
    if (!patientEhrid) return;
    const patientId = props.match.params.patientid;
    const visitId = props.match.params.visitid;

    dispatch(
      patientActions.getPatientProcedureInfo(patientId, visitId, "showAllVisits", (resCb) => {
        if (resCb?.patientresp?.procedureslist) {
          const labReports = resCb.patientresp.procedureslist.filter(
            (proc) => proc.subgroup?.includes("Lab_Report")
          );
          if (labReports.length > 0) {
            let allLabData = [];
            let processedCount = 0;
            labReports.forEach((report) => {
              if (report.compositionId) {
                dispatch(
                  ehrActions.getCompositionByVid({}, report.compositionId, patientEhrid, (compositionResponse) => {
                    if (compositionResponse) {
                      const extracted = extractLabTestValuesFromComposition(compositionResponse);
                      if (extracted) allLabData.push(extracted);
                    }
                    processedCount++;
                    if (processedCount === labReports.length) {
                      const combinedLabData = allLabData.join("\n---\n");
                      setSummary(prev => ({
                        ...prev,
                        "Clinical Investigations": combinedLabData || prev["Clinical Investigations"],
                      }));
                      setLabReportData(combinedLabData);
                    }
                  })
                );
              } else {
                processedCount++;
              }
            });
          }
        }
      })
    );
  };

  const extractLabTestValuesFromComposition = (composition) => {
    if (!composition?.content) return "";
    let outputLines = [];
    try {
      for (let content of composition.content) {
        if (!content.data?.events) continue;
        for (let event of content.data.events) {
          if (!event.data?.items) continue;
          let mainComment = "";
          let mainTestName = null;
          let subTests = [];
          for (let item of event.data.items) {
            if (item._type === "ELEMENT" && item.name?.value === "COMMENT") {
              if (item.value?.value) mainComment = item.value.value;
              break;
            }
          }
          for (let item of event.data.items) {
            if (item._type !== "CLUSTER") continue;
            let testName = "", resultValue = "", unit = "";
            if (item.items) {
              for (let subItem of item.items) {
                const fieldName = subItem.name?.value;
                if (fieldName === "Analyte name") testName = subItem.value?.value || "";
                if (fieldName === "Analyte result" && subItem.value) {
                  if (subItem.value.magnitude !== undefined) {
                    resultValue = subItem.value.magnitude;
                    unit = subItem.value.units || "";
                  } else if (subItem.value.value !== undefined) {
                    resultValue = subItem.value.value;
                  }
                }
              }
            }
            if (testName && resultValue === "") {
              if (mainTestName !== null) {
                let line = mainTestName;
                if (subTests.length > 0) line += `: ${subTests.join(", ")}`;
                if (mainComment) line += `, ${mainComment}`;
                outputLines.push(line);
                subTests = [];
              }
              mainTestName = testName;
            } else if (testName && resultValue !== "") {
              subTests.push(unit ? `${testName}:${resultValue} ${unit}` : `${testName}:${resultValue}`);
            }
          }
          if (mainTestName !== null || subTests.length > 0) {
            let line = mainTestName || "";
            if (subTests.length > 0) line = line ? `${line}: ${subTests.join(", ")}` : subTests.join(", ");
            if (mainComment) line += `, ${mainComment}`;
            if (line) outputLines.push(line);
          }
        }
      }
    } catch (e) {
      console.error("Lab formatting error", e);
    }
    return outputLines.join("\n");
  };



  const handleInputChange = (name, value) => {
    //console.log("value : " , value, "🟡🟡🟡🟡🟡🟡🟡🟡🟡🟡🟡🟡 handleInputChange:", name, "| userHasEdited:", userHasEdited.current, "| isDataLoaded:", isDataLoaded);
    userHasEdited.current = true;
    let updatedFormErrors = { ...formErrors };
    var summarydata = summary;
    formErrors[name] = "";
    var note = details;
    var keyList = [];
    summarydata[name] = value;
    note[name] = value;
    /*if (filterdProList && filterdProList.length > 0) {
      filterdProList.forEach((item) => {
        if (item.claSS == name) {
          keyList.push({
            claSS: item.claSS,
            notes: value,

            id: item.id,
            patientId: item.patientId,
            visitId: item.visitId,
          });
        }
        console.log("Setting  filterd prolist",keyList.length);
        setfilterdProList([...keyList]);
      });
      console.log("List filtered : ", filterdProList);
    }*/
    setSummary({ ...summarydata });
    //  console.log("🔥3️⃣🔥 setSummary - CASERECORD fallback:", new Error().stack);
    setDetails({ ...note });
  };



  const handleInputChangeOnReactQuill = (name, value, source) => {
    console.log("Source  : ", source);
    if (source !== "user") return;
    console.log("Now user so editing");

    userHasEdited.current = true;
    let updatedFormErrors = { ...formErrors };
    var summarydata = summary;
    formErrors[name] = "";
    var note = details;
    var keyList = [];
    summarydata[name] = value;
    note[name] = value;
    /*if (filterdProList && filterdProList.length > 0) {
      filterdProList.forEach((item) => {
        if (item.claSS == name) {
          keyList.push({
            claSS: item.claSS,
            notes: value,

            id: item.id,
            patientId: item.patientId,
            visitId: item.visitId,
          });
        }
        console.log("Setting  filterd prolist",keyList.length);
        setfilterdProList([...keyList]);
      });
      console.log("List filtered : ", filterdProList);
    }*/
    setSummary({ ...summarydata });
    //  console.log("🔥3️⃣🔥 setSummary - CASERECORD fallback:", new Error().stack);
    setDetails({ ...note });
  };



  const handlePrint = (event) => {
    if (selectedItemsDoc) {
      setDoctors(selectedItemsDoc.map((el) =>
        `${el.displaytitle} ${el.first_name || ""} ${el.last_name || ""}, Dep of ${el.department} (${el.qualification})`
      ));
    }
    if (selectedItemsCouns) {
      setCounsellor(selectedItemsCouns.map((el) =>
        `${el?.displaytitle || ""}${`${el?.first_name || ""} ${el?.last_name || ""}`.trim()}${el.qualification ? ` (${el.qualification})` : ""}`
      ));
    }
    if (selectedItemsStaff) {
      setMedicalOfficers(selectedItemsStaff.map((el) =>
        (`${el?.displaytitle || ""}${`${el?.first_name || ""} ${el?.mname || ""} ${el?.last_name || ""}`.trim()}${el.qualification ? ` (${el.qualification})` : ""}`).toUpperCase()
      ));
    }
    // ADDED FOR TELE-CONSULTATION
    const teleConsultDoctorsList = selectedItemsTeleDoc.map((el) =>
      `${el.displaytitle || ""} ${el.first_name || ""} ${el.last_name || ""}, Dep of ${el.department || ""} (${el.qualification || ""})`
    );
    setTeleConsultDoctors(teleConsultDoctorsList);
    
    setSummary((prev) => ({ ...prev, "Advice on discharge": getDischargeAdviceList() }));
    //console.log("🔥3️⃣🔥 setSummary - CASERECORD fallback:", new Error().stack);
    setdischargePrint(true);
  };

  const handleDischargePrint = () => setdischargePrint(false);

  const validateField = (fieldName, value) => {
    let fieldValidationErrors = formErrors;
    const textContent = (value != null ? String(value) : "").replace(/<[^>]*>/g, "");
    switch (fieldName) {
      case "Final Diagnosis":
        fieldValidationErrors["Final Diagnosis"] = textContent.length > 0 ? "" : "Please Enter Final Diagnosis";
        break;
      case "Clinical Summary":
        fieldValidationErrors["Clinical Summary"] =
          textContent.length === 0 ? "Please Enter Clinical Summary"
            : textContent.length > 800 ? "Clinical Summary exceed limit of 800 characters"
              : "";
        break;
      default: break;
    }
    setFormErrors(fieldValidationErrors);
  };

  const handleSubmit = async (event) => {
    const patientId = props.match.params.patientid;
    const visitId = props.match.params.visitid;
    userHasEdited.current = false;
    if (!mySessionIdRef.current) {
      setServerRes({ error: "Session not initialized. Please refresh and try again." });
      setTimeout(() => setServerRes({ success: "", error: "" }), 3000);
      return;
    }

    const sessionValid = await new Promise((resolve) => {
      dispatch(
        patientActions.validateSessionId(patientId, visitId, mySessionIdRef.current, (res) => {
          if (res?.successMessages) {
            resolve(true);
          } else {
            setSessionExpired(true);
            setSessionOwner(
              res?.errorMessages
                ? (Array.isArray(res.errorMessages) ? res.errorMessages[0] : res.errorMessages)
                : "another user"
            );
            resolve(false);
          }
        })
      );
    });

    if (!sessionValid) return;

    const curDate = format(new Date(), "yyyy-MM-dd");
    const fieldValidationErrors = { ...formErrors };
    fieldValidationErrors["Follow Up Date"] = patientRevisitdetails < curDate ? "Please Enter valid Follow up Date" : "";
    setFormErrors(fieldValidationErrors);
    Object.keys(summary).forEach((key) => validateField(key, summary[key]));
    validateForm(event);
  };

  const setMessageStrip = (e) => {
    const ServerResVal = { ...ServerRes };
    if (e.success) ServerResVal.success = e.success;
    else ServerResVal.error = e.error;
    setServerRes(ServerResVal);
    setTimeout(() => closeAlert(), 5000);
  };

  const validateForm = (event, silent = false) => {
    const formValid =
      formErrors["Final Diagnosis"] === "" &&
      formErrors["Clinical Summary"] === "" &&
      formErrors["Follow Up Date"] === "";

    for (let key in formErrors) {
      if (formErrors[key] !== "") {
        if (!silent) setMessageStrip({ error: "Please check there is a validation error in the discharge summary form" });
        return;
      }
    }

    if (formValid) {
      details.patientId = props.match.params.patientid;
      details.visitId = props.match.params.visitid;
      details.id = dischargeId;
      details.groupname = DISCHARGESUMMARY;
      var proList = [];
      var dischargeddt = [];
      const currentSummary = summary;
      const keys = Object.keys(summary);

      /*if (summary && summary.length > 0) {
        console.log("filterdProList greater than 0")
        summary.forEach((item) => {
          if (item.claSS === "session_id") return;
          proList.push({
            id: item.id,
            claSS: item.claSS,
            notes: item.claSS === "Advice on discharge"
              ? JSON.stringify(getDischargeAdviceList())
              : currentSummary[item.claSS],
            patientId: item.patientId,
            visitId: item.visitId,
          });
          if (item.claSS === "dischargedt") {
            dischargeddt.push({ id: item.visitId, patientId: item.patientId, dischargeDate: item.notes });
          }
        });
      } else {
        console.log("filterdProList not greater than 0")
        for (let key of keys) {
          proList.push({
            claSS: key,
            notes: currentSummary[key],
            patientId: props.match.params.patientid,
            visitId: props.match.params.visitid,
          });
          if (key === "dischargedt") {
            dischargeddt.push({
              id: props.match.params.visitid,
              patientId: props.match.params.patientid,
              dischargeDate: currentSummary[key],
            });
            setDischrgeDetails(dischargeddt);
          }
        }
        proList.push({
          claSS: "Advice on discharge",
          notes: JSON.stringify(getDischargeAdviceList()),
          patientId: props.match.params.patientid,
          visitId: props.match.params.visitid,
        });
      } */

      for (let key of keys) {
        if (key === "session_id") continue;
        proList.push({
          claSS: key,
          notes: key === "Advice on discharge"
            ? JSON.stringify(getDischargeAdviceList())
            : currentSummary[key],
          patientId: props.match.params.patientid,
          visitId: props.match.params.visitid,
        });
        if (key === "dischargedt") {
          dischargeddt.push({
            id: props.match.params.visitid,
            patientId: props.match.params.patientid,
            dischargeDate: currentSummary[key],
          });
          setDischrgeDetails(dischargeddt);
        }
      }

      const buildAssignments = (items, type) =>
        (items || []).map((item) => ({
          targetid: item.personId,
          visitid: props.match.params.visitid,
          status: "open",
          type,
        }));
      const assignmentList = [
        ...buildAssignments(selectedItemsDocRef.current, "Doctor"),
        ...buildAssignments(selectedItemsCounsRef.current, "counsellor"),
        ...buildAssignments(selectedItemsStaffRef.current, "Medical Officer"),
        ...buildAssignments(selectedItemsTeleDocRef.current, "Tele-consultation"), // ADDED FOR TELE-CONSULTATION
      ];

      dispatch(patientActions.saveDischargeSummary(proList, (resCb) => {
        if (resCb) {
          if (resCb.successMessages) {
            if (!silent) setServerRes({ success: "Discharge summary added successfully" });
            saveDischargeSummaryinEhr();
            refreshAssignmentIds(); // ← add this
          } else if (resCb.errorMessages) {
            if (!silent) setServerRes({ error: "Failed to add Discharge summary" });
          }
          if (!silent) setTimeout(() => setServerRes({ success: "", error: "" }), 3000);
        }
      }));

      dispatch(patientActions.followUpByDoctor(
        { patientId: props.match.params.patientid, lastvisitId: props.match.params.visitid, scheduleddate: patientRevisitdetails },
        (resCb) => {
          if (resCb && !silent) {
            if (resCb.successMessages) setServerRes({ success: "Discharge summary added successfully" });
            else if (resCb.errorMessages) setServerRes({ error: "Failed to add Discharge summary" });
            setTimeout(() => setServerRes({ success: "", error: "" }), 3000);
          }
        }
      ));

      if (assignmentList.length > 0) {
        dispatch(patientActions.saveVisitAssignment(assignmentList, (resCb) => {
          if (!resCb || silent) return;
          if (resCb.successMessages) setServerRes({ success: "Discharge summary added successfully.", error: "" });
          else if (resCb.errorMessages) setServerRes({ success: "", error: "Failed to add Discharge summary" });
          setTimeout(() => setServerRes({ success: "", error: "" }), 3000);
        }));
      }

      if (!silent && dischargeddt.length > 0) {
        dispatch(patientActions.saveDischargeDate(dischargeddt, (resCb) => {
          if (resCb) {
            if (resCb.successMessages) setServerRes({ success: "Discharge summary added successfully." });
            else setServerRes({ error: "Failed to add Discharge summary" });
            setTimeout(() => setServerRes({ success: "", error: "" }), 3000);
          }
        }));
      }

      if (!silent) {
        setMessageStrip({ success: event?.successMessages });
        setTimeout(() => closeAlert(), 3000);
      }
    } else {
      if (!silent) {
        setLoadSummary(!loadsummary);
        setMessageStrip({ error: "Please check there is an validation error in the discharge summary form" });
      }
    }
  };

  const saveDischargeSummaryinEhr = () => {
    if (!dischargeSummarytemplate?.composer) return;
    if (!dischargeSummarytemplate.content?.[0]?.items) return;

    dischargeSummarytemplate.content[0].items.map((item) => {
      const fieldname = item.name.value;
      let i = item?.data?.events?.[0]?.data?.items?.[0]?.value?.value;
      const fieldMap = {
        "Final Diagnosis": "Final Diagnosis",
        "Clinical Summary": "Clinical Summary",
        "Past and Treatment History": "Past and Treatment History",
        "Chief Complaints": "Chief Complaints",
        "Relevant Medical History": "Relevant Medical History",
        "Relevant Family History": "Relevant Family History",
        "Personal History": "Personal History",
        "Mental State Examination": "Mental State Examination",
        "Clinical Investigations": "Clinical Investigations",
      };
      if (fieldMap[fieldname]) i = summary[fieldMap[fieldname]] || i;
      else if (fieldname === "FollowUp Date") i = patientRevisitdetails || i;
      else if (fieldname === "Discharge Date") i = dischargedt || i;

      if (item?.data?.events?.[0]?.data?.items?.[0]?.value) {
        item.data.events[0].data.items[0].value.value = i;
        item.subject.name = selectedDoctor;
      }
    });

    dispatch(ehrActions.saveComposition(
      dischargeSummarytemplate,
      props.match.params.patientid,
      props.match.params.visitid,
      "Discharge Summary",
      patientEhrid,
      "Discharge summary saved in ehr",
      props.selectedProcedure ?? null,
      (resCb) => { if (resCb) console.log("EHR save response:", resCb); }
    ));
  };

  const closeAlert = () => setServerRes({ success: "", error: "" });

  const handleOptionSelect = (selectedDoctorId) => {
    //userHasEdited.current = true;
    // setSummary(prev => ({ ...prev }));

    const visitId = props.match.params.visitid;

    let newItem = null;
    let type = null;

    doctorList.forEach((doc) => {
      if (doc.personId == selectedDoctorId && !selectedItemsDoc.some((i) => i.personId === doc.personId)) {
        newItem = doc;
        type = "Doctor";
        setSelectedItemsDoc((prev) => [...prev, doc]);
        setSelectedOptionDoc(selectedDoctorId);
      }
    });
    counsellorList.forEach((c) => {
      if (c.personId == selectedDoctorId && !selectedItemsCouns.some((i) => i.personId === c.personId)) {
        newItem = c;
        type = "counsellor";
        setSelectedItemsCoun((prev) => [...prev, c]);
        setSelectedOptionCoun(selectedDoctorId);
      }
    });
    staffList.forEach((s) => {
      if (s.personId == selectedDoctorId && !selectedItemsStaff.some((i) => i.personId === s.personId)) {
        newItem = s;
        type = "Medical Officer";
        setSelectedItemsStaff((prev) => [...prev, s]);
        setSelectedOptionStaff(selectedDoctorId);
      }
    });

    if (newItem && type) {
      dispatch(patientActions.saveVisitAssignment([{
        targetid: newItem.personId,
        visitid: visitId,
        status: "open",
        type,
      }], () => {
        refreshAssignmentIds();
      }));
    }
  };

  const handleRemoveItem = (item) => {
    const updated = selectedItemsDoc.filter((i) => i !== item);
    selectedItemsDocRef.current = updated;
    setSelectedItemsDoc(updated);
    //setSummary(prev => ({ ...prev }));
    userHasEdited.current = false;
    dispatch(patientActions.removeVisitAssignment([{
      id: item.vaId || null,
      targetid: item.personId,
      visitid: props.match.params.visitid,
      status: "close",
      type: "Doctor",
    }], () => { }));
  };

  const handleRemoveItemCoun = (item) => {
    const updated = selectedItemsCouns.filter((i) => i !== item);
    selectedItemsCounsRef.current = updated;
    setSelectedItemsCoun(updated);
    //setSummary(prev => ({ ...prev }));
    userHasEdited.current = false;

    dispatch(patientActions.removeVisitAssignment([{
      id: item.vaId || null,
      targetid: item.personId,
      visitid: props.match.params.visitid,
      status: "close",
      type: "counsellor",
    }], () => { }));
  };

  const handleRemoveItemStaff = (item) => {
    const updated = selectedItemsStaff.filter((i) => i !== item);
    selectedItemsStaffRef.current = updated;
    setSelectedItemsStaff(updated);
    // setSummary(prev => ({ ...prev }));
    userHasEdited.current = false;

    dispatch(patientActions.removeVisitAssignment([{
      id: item.vaId || null,
      targetid: item.personId,
      visitid: props.match.params.visitid,
      status: "close",
      type: "Medical Officer",
    }], () => { }));
  };
  const ChangeRevisitDate = (event) => {
    const val = event.target.value;
    setPatientRevisitdetails(val);
    const curDate = format(new Date(), "yyyy-MM-dd");
    setFormErrors((prev) => ({
      ...prev,
      "Follow Up Date": val < curDate ? "Please Enter valid Follow up Date" : "",
    }));

    if (val >= curDate) {
      dispatch(patientActions.followUpByDoctor(
        {
          patientId: props.match.params.patientid,
          lastvisitId: props.match.params.visitid,
          scheduleddate: val,
        },
        () => { }
      ));
    }
  };
  const handleRowChange = (index, field, value) => {
    const updatedRows = [...adviceRows];
    updatedRows[index][field] = value;
    setAdviceRows(updatedRows);
    handleInputChange("Advice on discharge", JSON.stringify(getDischargeAdviceList()));
  };

  const addRow = () => {
    setAdviceRows([...adviceRows, { medicine: "", dose: "", frequency: "", comment: "" }]);
  };

  const getDischargeAdviceList = () => {
    return adviceRows.filter(
      (row) => row.medicine.trim() !== "" || row.dose.trim() !== "" || row.frequency.trim() !== "" || row.comment.trim() !== ""
    );
  };

  const renderQuill = (label, fieldName, required = false) => (
    <div className="py-3 pl-0 col-lg-6 col-xl-6 col-md-6 col-12" id="bgclr">
      <div style={{ marginBottom: "5px" }}>
        <label className="summary-label">
          {label}{" "}
          {required && <span className={`${classes.redAsterisk} MuiInputLabel-asterisk`}>*</span>}
        </label>
      </div>
      <ReactQuill
        theme="snow"
        value={summary[fieldName]}
        onChange={(content, delta, source) => {
          handleInputChangeOnReactQuill(fieldName, content, source);
        }}
        modules={modules}
        className={classes.quillEditor}
      />

      <div style={{ color: "#EC4147" }}>
        <span className="summary-label">{formErrors[fieldName]}</span>
      </div>
    </div>
  );

  return (
    <>
      {console.log(" CURRENT summary state:", summary["Appointment Confirmation Number"])}
      {sessionExpired && (

        <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.6)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ background: "white", padding: "30px", borderRadius: "8px", textAlign: "center" }}>
            <h5>Session Expired</h5>
            <p>This discharge summary is currently being edited by <strong>{sessionOwner}</strong>.<br />Please close and reopen to continue.</p>
            <button className="btn btn-danger" onClick={() => { window.open("", "_self"); window.close(); }}>Close</button>
          </div>
        </div>
      )}
      {ServerRes.success && (
        <Alert severity="success" className="alert-div">
          {ServerRes.success}{" "}
          <IconButton aria-label="close" color="inherit" size="small" onClick={closeAlert}><CloseIcon fontSize="inherit" /></IconButton>
        </Alert>
      )}
      {ServerRes.error && (
        <Alert severity="error" className="alert-div">
          {ServerRes.error}{" "}
          <IconButton aria-label="close" color="inherit" size="small" onClick={closeAlert}><CloseIcon fontSize="inherit" /></IconButton>
        </Alert>
      )}
      <div className="bg-none nav-wrapper h-100 d-flex flex-column summary-view">

        {autosaveStatus !== "idle" && (
          <div style={{
            position: "fixed",
            top: 16,
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 10000,
            display: "flex",
            alignItems: "center",
            gap: "8px",
            background: "#fff",
            padding: "10px 24px",
            borderRadius: "20px",
            boxShadow: "0 1px 6px rgba(0,0,0,0.10)",
            border: "1px solid #e0e0e0",
          }}>
            {autosaveStatus === "saving" && (
              <small style={{ color: "#1976d2", fontWeight: 500, fontSize: "30px" }}>
                ⟳ Saving...
              </small>
            )}
            {autosaveStatus === "saved" && (
              <small style={{ color: "#2e7d32", fontWeight: 500, fontSize: "30px" }}>
                ✓ Saved
              </small>
            )}
          </div>
        )}

        <div className="pres-header" style={{ position: "sticky", top: 0, zIndex: 100, background: "white" }}>
          <div className="pres-layout-basic-info" style={{ position: "fixed", top: "48px", left: 0, right: 0, zIndex: 99, background: "white", boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
            <div className="main-content-container container-fluid p-0">
              <div className="mb-12 col-md-12 hpcol bg menu-head">
                <div className="blog-comments__item d-flex cpointer p-2 menu-content">
                  <div className="blog-comments__content layout-head-content">
                    <div className="blog-comments__meta text-mutes d-flex img-name justify-content-between">
                      <div className="d-flex align-items-center">
                        <div className="text-secondary pname px-2" style={{ textTransform: "capitalize" }}>{fullName}</div>
                      </div>
                      <div className="d-flex flex-column">
                        {Array.isArray(roomList) && roomList.length > 0 && (
                          <small className="text-muted" style={{ fontWeight: 300, display: "flex", gap: "8px", flexWrap: "wrap", alignItems: "center" }}>
                            <i className="material-icons p-icon">bed</i>
                            {roomList.map((room) => room.floorId ? `Floor ${room.floorId} - ${room.roomName}` : room.roomName).join(", ")}
                          </small>
                        )}
                        {phoneNum && (
                          <small className="text-muted" style={{ fontWeight: 300, display: "flex", gap: "8px", flexWrap: "wrap", alignItems: "center" }}>
                            <i className="material-icons p-icon">phone</i>
                            <span>{phoneNum}</span>
                          </small>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex h-100 px-3" id="discharge">
          <div className="px-2 w-100">
            <div className="w-100 service-container" style={{ overflowY: "auto" }}>
              <div className="w-100 flex-wrap flex-column px-3">
                <span>
                  <Box className="row service-form">
                    <div className="py-3 pl-0 col-lg-3" id="bgclr">
                      <select
                        style={{ padding: "17px" }}
                        className="p-2 form-control filterin Quantity"
                        value={summary["patient title"]}
                        onChange={(e) => handleInputChange("patient title", e.target.value)}
                      >
                        <option disabled value="">--Select Title--</option>
                        <option value="Mr">Mr</option>
                        <option value="Miss">Miss</option>
                        <option value="Mrs">Mrs</option>

                      </select>
                    </div>

                    {/* ── Standard text inputs ── */}
                    <div className="py-3 pl-0 col-lg-3" id="bgclr">
                      <TextField
                        fullWidth
                        label="Appointment Confirmation Number"
                        className="p-2"
                        value={summary["Appointment Confirmation Number"]}
                        autoComplete="off"
                        onChange={(e) => handleInputChange("Appointment Confirmation Number", e.target.value)}
                      />
                    </div>
                    <div className="py-3 pl-0 col-lg-3" id="bgclr">
                      <select
                        style={{ padding: "17px" }}
                        className="p-2 form-control filterin Quantity"
                        value={summary["Admission Type"]}
                        onChange={(e) => handleInputChange("Admission Type", e.target.value)}
                      >
                        <option disabled value="">--Choose admission type--</option>
                        <option value="Independent">Independent</option>
                        <option value="Supported">Supported</option>
                      </select>
                    </div>
                    {summary["Admission Type"] === "Supported" && (
                      <div className="py-3 pl-0 col-lg-3" id="bgclr">
                        <input
                          className="p-2 form-control filterin Quantity"
                          value={summary["supportDate"]}
                          required
                          type="date"
                          onChange={(e) => handleInputChange("supportDate", e.target.value)}
                        />
                      </div>
                    )}
                    <div className="py-3 pl-0 col-lg-3" id="bgclr">
                      <TextField
                        fullWidth
                        label="Ksmha Intimation Number"
                        className="p-2"
                        value={summary["Ksmha Intimation Number"]}
                        autoComplete="off"
                        onChange={(e) => handleInputChange("Ksmha Intimation Number", e.target.value)}
                      />
                    </div>
                    <div className="py-3 pl-0 col-lg-3 col-xl-3 col-md-3 col-12" id="bgclr">
                      <TextField
                        fullWidth
                        label="Nominated Representative"
                        className="p-2"
                        value={summary["Nominated Representative"]}
                        autoComplete="off"
                        onChange={(e) => handleInputChange("Nominated Representative", e.target.value)}
                      />
                    </div>
                    <div className="py-3 pl-0 col-lg-6 col-xl-6 col-md-6 col-12" id="bgclr">
                      <TextField
                        fullWidth
                        label="Package of Stay"
                        className="p-2"
                        value={summary["Package of Stay"] }
                        autoComplete="off"
                        onChange={(e) => handleInputChange("Package of Stay", e.target.value)}
                      />
                    </div>

                    {/* ── Rich text (Quill) fields ── */}
                    {renderQuill("Final Diagnosis", "Final Diagnosis", true)}
                    {renderQuill("Chief Complaints", "Chief Complaints")}
                    {renderQuill("Clinical History", "Clinical Summary", true)}
                    {renderQuill("Past History", "Past and Treatment History")}
                    {renderQuill("Medical History", "Relevant Medical History")}
                    {renderQuill("Family History", "Relevant Family History")}
                    {renderQuill("Personal History", "Personal History")}
                    {renderQuill("Premorbid Personality", "Premorbid Personality")}
                    {renderQuill("Mental State Examination", "Mental State Examination")}
                    {renderQuill("General physical examination", "General physical examination")}
                    {renderQuill("Clinical Investigations", "Clinical Investigations")}
                    {renderQuill("COURSE AND MANAGEMENT IN THE HOSPITAL", "Course of treatment in hospital")}
                    {renderQuill("Planned Psycho-Social Intervention", "Planned Psycho-Social Intervention")}
                    {renderQuill("Stressors", "Stressors")}
                    {renderQuill("Forensic History", "Forensic History")}
                    {renderQuill("Systemic Examination", "Systemic Examination")}
                    {renderQuill("Capacity Assessment", "Capacity Assessment")}
                    {renderQuill("Other Reports", "Other Reports")}
                    {renderQuill("Other Consultation", "Other Consultation")}
                    {renderQuill("Relapse Prevention Measures", "Relapse Prevention Measures")}
                    {renderQuill("Restriction in Physical activity / Work", "Restriction in Physical activity")}
                    {renderQuill("Diet", "Diet")}
                    {renderQuill("Next dose of long Acting Injectable (Depot) due", "Next dose of long Acting Injectable due")}

                    {/* ── Advice on Discharge table ── */}
                    <div className="py-3 pl-0 col-12" id="bgclr">
                      <label className="summary-label mb-2">Advice on Discharge</label>
                      {adviceRows.map((row, index) => (
                        <div className="row mb-2" key={index}>
                          <div className="col-md-3 col-12">
                            <TextField fullWidth size="small" label="Medicine Name" value={row.medicine} onChange={(e) => handleRowChange(index, "medicine", e.target.value)} />
                          </div>
                          <div className="col-md-2 col-12">
                            <TextField fullWidth size="small" label="Dose" value={row.dose} onChange={(e) => handleRowChange(index, "dose", e.target.value)} />
                          </div>
                          <div className="col-md-3 col-12">
                            <TextField fullWidth size="small" label="Frequency" value={row.frequency} onChange={(e) => handleRowChange(index, "frequency", e.target.value)} />
                          </div>
                          <div className="col-md-4 col-12">
                            <TextField fullWidth size="small" label="Comment" value={row.comment} onChange={(e) => handleRowChange(index, "comment", e.target.value)} />
                          </div>
                        </div>
                      ))}
                      <button type="button" className="btn btn-sm btn-outline-primary mt-2" onClick={addRow}>+ Add Medicine</button>
                    </div>

                    {/* ── Radio groups ── */}
                    <div className="py-3 pl-0 col-lg-3 col-xl-3 col-md-3 col-12" id="bgclr">
                      <FormControl>
                        <FormLabel>Risk of Self Harm</FormLabel>
                        <RadioGroup row value={summary["Risk of Self Harm"]} onChange={(e) => handleInputChange("Risk of Self Harm", e.target.value)}>
                          <FormControlLabel value="Present" control={<Radio size="small" />} label="Present" />
                          <FormControlLabel value="Not Present" control={<Radio size="small" />} label="Not Present" />
                        </RadioGroup>
                      </FormControl>
                    </div>
                    <div className="py-3 pl-0 col-lg-3 col-xl-3 col-md-3 col-12" id="bgclr">
                      <FormControl>
                        <FormLabel>Communicated To</FormLabel>
                        <RadioGroup row value={summary["Communicated To"]} onChange={(e) => handleInputChange("Communicated To", e.target.value)}>
                          <FormControlLabel value="Family Member" control={<Radio size="small" />} label="Family Member" />
                          <FormControlLabel value="Caregiver" control={<Radio size="small" />} label="Caregiver" />
                        </RadioGroup>
                      </FormControl>
                    </div>

                    {/* ── Doctor/Counsellor/Staff selects ── */}
                    <div className="py-3 pl-0 col-lg-3 col-xl-3 col-md-3 col-12">
                      <label className="summary-label">Treating Doctor</label>
                      <select className="form-control filterin Quantity" value={selectedOptionDoc || ""} onChange={(e) => handleOptionSelect(e.target.value)}>
                        <option disabled value="">---Select doctor---</option>
                        {doctorList.map((doctor) => (
                          <option key={doctor.personId} value={doctor.personId}>
                            {`${doctor.displaytitle || ""} ${doctor.first_name || ""} ${doctor.last_name || ""}, Dep of ${doctor.department || ""} (${doctor.qualification || ""})`}
                          </option>
                        ))}
                      </select>
                    </div>
                    {selectedItemsDoc.length > 0 && (
                      <div className="py-3 pl-0 col-lg-3 col-xl-3 col-md-3 col-12">
                        <label className="summary-label">Selected Doctors</label>
                        <div className="border" style={{ maxHeight: "140px", overflowY: "auto", borderRadius: "5px", background: "white" }}>
                          {selectedItemsDoc.map((item) => (
                            <div key={item.personId} className="d-flex p-1" style={{ justifyContent: "space-between", alignItems: "center" }}>
                              <label>{`${item.displaytitle || ""} ${item.first_name || ""} ${item.last_name || ""}, Dep of ${item.department || ""} (${item.qualification || ""})`}</label>
                              <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => handleRemoveItem(item)}>Cancel</button>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                    <div className="pt-3 pl-0 col-lg-3 col-xl-3 col-md-3 col-12">
                      <label className="summary-label">Treating Counsellor</label>
                      <select className="form-control filterin Quantity" value={selectedOptionCoun || ""} onChange={(e) => handleOptionSelect(e.target.value)}>
                        <option disabled value="">---Select Counsellor---</option>
                        {counsellorList.map((c) => (
                          <option key={c.personId} value={c.personId}>{c.displaytitle} {c.first_name}</option>
                        ))}
                      </select>
                    </div>
                    {selectedItemsCouns.length > 0 && (
                      <div className="py-3 pl-0 col-lg-3 col-xl-3 col-md-3 col-12">
                        <label className="summary-label">Selected Counsellor</label>
                        <div className="border" style={{ maxHeight: "140px", overflowY: "auto", borderRadius: "5px", background: "white" }}>
                          {selectedItemsCouns.map((item) => (
                            <div key={item.personId} className="d-flex p-1" style={{ justifyContent: "space-between", alignItems: "center" }}>
                              <label>{item.displaytitle} {item.first_name}</label>
                              <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => handleRemoveItemCoun(item)}>Cancel</button>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                    <div className="py-3 pl-0 col-lg-3 col-xl-3 col-md-3 col-12">
                      <label className="summary-label">Medical Officer</label>
                      <select className="form-control filterin Quantity" value={selectedOptionStaff || ""} onChange={(e) => handleOptionSelect(e.target.value)}>
                        <option disabled value="">---Select Medical Officer---</option>
                        {staffList.map((s, i) => (
                          <option key={s.personId || `staff-${i}`} value={s.personId}>{s.displaytitle} {s.first_name}</option>
                        ))}
                      </select>
                    </div>
                    {selectedItemsStaff.length > 0 && (
                      <div className="py-3 pl-0 col-lg-3 col-xl-3 col-md-3 col-12">
                        <label className="summary-label">Selected Medical Officer</label>
                        <div className="border" style={{ maxHeight: "140px", overflowY: "auto", borderRadius: "5px", background: "white" }}>
                          {selectedItemsStaff.map((item) => (
                            <div key={item.personId} className="d-flex p-1" style={{ justifyContent: "space-between", alignItems: "center" }}>
                              <label>{item.displaytitle} {item.first_name}</label>
                              <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => handleRemoveItemStaff(item)}>Cancel</button>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                    
                    {/* ── Tele-consultation appointments select ── */}
                    <div className="py-3 pl-0 col-lg-3 col-xl-3 col-md-3 col-12">
                      <label className="summary-label">Tele-consultation appointments</label>
                      <select
                        className="form-control filterin Quantity"
                        value={selectedTeleDoc || ""}
                        onChange={(e) => handleTeleOptionSelect(e.target.value)}
                      >
                        <option disabled value="">---Select doctor for Tele-consultation---</option>
                        {doctorList.map((doctor) => (
                          <option key={doctor.personId} value={doctor.personId}>
                            {`${doctor.displaytitle || ""} ${doctor.first_name || ""} ${doctor.last_name || ""}, Dep of ${doctor.department || ""} (${doctor.qualification || ""})`}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* ── Selected Tele-consultation Doctors ── */}
                    {selectedItemsTeleDoc.length > 0 && (
                      <div className="py-3 pl-0 col-lg-3 col-xl-3 col-md-3 col-12">
                        <label className="summary-label">Selected Tele-consultation Doctors</label>
                        <div className="border" style={{ maxHeight: "140px", overflowY: "auto", borderRadius: "5px", background: "white" }}>
                          {selectedItemsTeleDoc.map((item) => (
                            <div key={item.personId} className="d-flex p-1" style={{ justifyContent: "space-between", alignItems: "center" }}>
                              <label>{`${item.displaytitle || ""} ${item.first_name || ""} ${item.last_name || ""}, Dep of ${item.department || ""} (${item.qualification || ""})`}</label>
                              <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => handleRemoveTeleItem(item)}>Cancel</button>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                      
                    {/* ── Selected lists ── */}
                      
                    {/* ── Dates ── */}
                    <div className="py-3 pl-0 col-lg-12">
                      <div className="row">
                        <div className="col-lg-6" style={{ width: "fit-content" }}>
                          <label className="service-lable">Follow Up Date</label>
                          <input
                            name="scheduleddate"
                            id="scheduleddate"
                            className="form-control filterin Quantity"
                            required
                            type="date"
                            readOnly={followUpDateFlag}
                            min={todayDate}
                            defaultValue={patientRevisitdetails}

                            onChange={ChangeRevisitDate}
                          />
                          <div style={{ color: "#EC4147" }}>
                            <span className="summary-label">{formErrors["Follow Up Date"]}</span>
                          </div>
                        </div>
                        <div className="col-lg-6" style={{ width: "fit-content" }}>
                          <label className="service-lable">Discharge Date</label>
                          <input
                            name="dischargedate"
                            id="dischargedate"
                            className="form-control filterin Quantity"
                            required
                            type="datetime-local"
                            readOnly={dischargeDateFlag}
                            min={todayDate}
                            value={summary.dischargedt || ""}
                            onChange={(e) => handleInputChange("dischargedt", e.target.value)}
                          />
                        </div>
                      </div>
                    </div>

                    {/* ── Buttons ── */}
                    <div className="d-flex mx-1">
                      <button type="button" className="btn btn-primary" style={{ marginRight: "20px" }} onClick={handleSubmit}>Save</button>
                      <button type="button" className="ml-3 btn btn-primary" onClick={handlePrint}>Print</button>
                    </div>

                    {dischargePrint && (
                      <div className="">
                        <Components.PrintDischargeSummary
                          parentCallBack={handleDischargePrint}
                          patientdetails={patientdetails}
                          revisitDetails={patientRevisitdetails}
                          doctorList={doctors}
                          consellorlist={counsellor}
                          staffList={medicalOfficers}
                          summary={summary}
                          teleConsultDoctors={teleConsultDoctors}
                        />
                      </div>
                    )}
                  </Box>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DischargeSummary;